module.exports = __webpack_public_path__ + "static/media/icon_top_dark.8141ff02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_top_dark.svg
// module id = 870
// module chunks = 7